import { CalendarCheck, House, ListBullets } from '@phosphor-icons/react';
import { NavLink } from 'react-router';
import { GlassSurface } from '@/components/GlassSurface';

/**
 * Bottom navigation: three destinations from the brief. Fixed to the
 * bottom with safe-area padding; pages reserve its height so it never
 * covers content (see .with-bottom-nav in app.css).
 */
export function BottomNav({ slug }: { slug: string }) {
  const items = [
    { to: `/s/${slug}/`, label: 'Главная', icon: House, end: true },
    { to: `/s/${slug}/services`, label: 'Услуги', icon: ListBullets, end: false },
    { to: `/s/${slug}/my`, label: 'Моя запись', icon: CalendarCheck, end: false },
  ];
  return (
    <GlassSurface as="nav" snapshot="#studio-main" zIndex={40} tint="rgba(6, 7, 9, 0.62)" frost={10} className="bottom-nav" aria-label="Основная навигация">
      <ul className="bottom-nav__list">
        {items.map(({ to, label, icon: Icon, end }) => (
          <li key={to}>
            <NavLink to={to} end={end} className="bottom-nav__item">
              {({ isActive }) => (
                <>
                  <Icon size={24} weight={isActive ? 'fill' : 'regular'} aria-hidden />
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </GlassSurface>
  );
}
